import { memo } from "react";

import { DesignMagazineRoomListContainer } from "./container";

type Props = {
	hotelID: string;
};

export const DesignMagazineRoomList = memo(({ hotelID }: Props) => {
	return <DesignMagazineRoomListContainer hotelID={hotelID} />;
});

DesignMagazineRoomList.displayName = "DesignMagazineRoomList";
